module.exports = __webpack_public_path__ + "static/media/sylvainSarrailh.40ae2c89.jpg";